export default "__VITE_ASSET__CAqi8TGC__"